import React, { Component } from "react";
import { Dialog, TextField } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import { PrimaryButton, SecondaryButton, ButtonSizeOptions, MaterialIcon } from '@loanbossinc/component-library';
import CircularProgress from "@material-ui/core/CircularProgress";

const StyledPrimaryButton = styled(PrimaryButton)`&&&{
    margin-left: 24px;
}`;

const baseTextStyles = styled.div`
  font-family: Work Sans;
  font-style: normal;
`;

const StyledTitle = styled(baseTextStyles)`
  font-size: 24px;  
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;  
  padding-left: 20px;
  padding-top: 20px;
`;

const StyledDescription = styled(baseTextStyles)`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #5F6368;
  margin-bottom: 26px;
`;

const StyleDateField = styled(TextField)`
  background: #e8e8e8;

  label {
    padding: 8px 18px;
    color: #999999;
  }

  input {
    padding: 10px 12px;
    color: ${props => props.isEmpty && "rgba(0, 0, 0, 0.56);"};
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  width: 376px;
  justify-content: space-between;
`;
const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;
`;

const WorkflowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Line = styled.div`
  width: 156px;
  height: 0px;
  border: 1px solid #DADCE0;
  margin-left: 20px;
  margin-right: 20px;
`;

const StyledBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  width: 376px;
  margin-bottom: 20px;
`;

const StyledNumber = styled.span`
  position: relative;
  left: -23px;
  top: -13px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 14px;
  color: #FFFFFF;
`;
class DebtValuationExportModal extends Component {
  constructor(props) {
    super(props);
  }

  state = { isLoading: false };

  handleExportComplete = () => {
    this.setState({
      isLoading: false
    });
    this.props.onClose();
  };
  closeModal = () => this.props.onClose();

  onCancel = () => this.props.onClose();

  onExport = () => {
    this.setState({
      isLoading: true
    });
    this.props.onExport(this.handleExportComplete);
  };

  render() {
    const modalTitle = "Export Debt Valuation Data";
    const { isOpen, valuationDate, handleDatePicker } = this.props;
    const { isLoading } = this.state;

    return (

      <Dialog
        id="debtValuationExportModal"
        open={isOpen}
        onClose={this.closeModal}
        maxWidth="md" >

        <StyledTitle id="dvHeader">{modalTitle}</StyledTitle>

        {!isLoading && <Body>

          <StyledContentWrapper>

            <StyledDescription>Select an as of date to proceed with downloading your debt valuation data.</StyledDescription>

            <StyleDateField
              value={valuationDate}
              name="valuationDate"
              type="date"
              label="Select as of date"
              onChange={(e) => { handleDatePicker(e.target.value) }}

              inputProps={{ max: "2199-12-31" }}
            />
          </StyledContentWrapper>

          <StyledButtonWrapper>
            <SecondaryButton label="Cancel" size={ButtonSizeOptions.sm} onClick={this.onCancel} style={{ marginTop: '16px' }} />
            <StyledPrimaryButton label="Export" size={ButtonSizeOptions.sm} onClick={this.onExport} style={{ marginTop: '16px' }} />
          </StyledButtonWrapper>

        </Body>}

        {isLoading && <Body>

          <StyledContentWrapper>
            <StyledDescription>We are backdating the debt valuation calculations. Your file will begin downloading automatically. Please be patient, this may take some time.</StyledDescription>
          </StyledContentWrapper>

          <StyledBodyWrapper>
            <WorkflowWrapper>
              <MaterialIcon iconName={'check_circle'} style={{ fontSize: '36px', color: '#0F9AD6' }} />
              <Line />
              <div style={{ paddingTop: '8px' }}>
                <MaterialIcon iconName={'lens'} style={{ fontSize: '36px', color: '#0F9AD6' }} />
                <StyledNumber>2</StyledNumber>
              </div>
            </WorkflowWrapper>
            <CircularProgress />
          </StyledBodyWrapper>

          <StyledButtonWrapper>
            <StyledPrimaryButton label="Done" size={ButtonSizeOptions.sm} onClick={this.onCancel} style={{ marginTop: '16px' }} />
          </StyledButtonWrapper>

        </Body>}
      </Dialog>

    );
  }
}

export default (DebtValuationExportModal);
